var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeresesikon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Keres\\xE9s ikon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4431 20.9116C12.7671 20.9116 14.9402 20.1259 16.6908 18.8265L21.4144 23.5558C22.0059 24.1481 22.9657 24.1481 23.5571 23.5558C24.1487 22.9636 24.1475 22.0037 23.5543 21.4129L18.8337 16.7111C20.1315 14.9584 20.9163 12.8129 20.9163 10.4558C20.9163 4.68395 16.238 0 10.4732 0C4.70843 0 0 4.71417 0 10.4558C0 16.1974 4.70843 20.9116 10.4431 20.9116ZM10.6211 3.07857C14.791 3.07857 18.1637 6.34798 18.1637 10.3902C18.1637 14.4323 14.791 17.7018 10.6211 17.7018C6.45127 17.7018 3.07859 14.4323 3.07859 10.3902C3.07859 6.34798 6.48193 3.07857 10.6211 3.07857Z",
    fill: "#011111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeresesikon);
export default __webpack_public_path__ + "static/media/Kereses ikon.d3e0dd847f23084ec1cddfc95624805d.svg";
export { ForwardRef as ReactComponent };